module.exports = __webpack_public_path__ + "static/media/unlucky.946b2973.wav";